<template>
  <div>
    <a @click="fnShowModal()" class="p-2"
      ><i class="far fa-edit text-primary"></i
    ></a>

    <b-modal ref="modal" hide-footer title="Financier - update">
      <div class="d-block">
        <form>
          <div class="form-group">
            <label for="name">Name</label>
            <input
              type="text"
              class="form-control"
              id="name"
              placeholder="Name"
              v-model="name"
            />
            <div class="invalid-feedback" v-if="errors.name">
              {{ errors.name[0] }}
            </div>
          </div>

          <div class="form-group">
            <label for="name">Rate</label>
            <input
              type="number"
              class="form-control"
              placeholder="Rate"
              v-model="rate"
            />
            <div class="invalid-feedback" v-if="errors.rate">
              {{ errors.rate[0] }}
            </div>
          </div>
          <div class="form-group">
            <label for="description">Description</label>
            <input
              type="text"
              class="form-control"
              id="description"
              placeholder="Description"
              v-model="description"
            />
          </div>
          <section>
            <div>
              <b-form-checkbox
                id="checkbox-2"
                v-model="defaultFinancier"
                name="checkbox-2"
                value="1"
                unchecked-value="0"
              >
                Is Default Financier
              </b-form-checkbox>
            </div>
          </section>

          <section>
            <div>
              <b-form-checkbox
                id="checkbox-1"
                v-model="status"
                name="checkbox-1"
                value="1"
                unchecked-value="0"
              >
                Status
              </b-form-checkbox>
            </div>
          </section>

          <hr />
          <div class="text-right">
            <button
              type="button"
              class="btn btn-secondary btn-sm mr-2"
              @click="hideModal"
            >
              Cancel
            </button>
            <button
              type="button"
              @click="fnUpdate()"
              class="btn btn-success btn-sm"
            >
              Update
            </button>
          </div>
        </form>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import * as messageService from '../../services/message.service'
import * as financierService from '../../services/financier.service'
export default {
  name: 'ModalFinancierEdit',
  props: ['propsData'],
  components: {},
  data() {
    return {
      errors: {},
      id: '',
      name: '',
      rate: 0,
      description: '',
      defaultFinancier: 0,
      status: ''
    }
  },
  computed: {
    ...mapGetters(['getFinancierPaginateData', 'getFinancierPaginate'])
  },
  methods: {
    ...mapActions(['fetchFinancierPaginate']),
    fnShowModal() {
      this.fnGetValue(this.propsData)
      this.showModal()
    },
    hideModal() {
      this.$refs.modal.hide()
    },
    showModal() {
      this.$refs.modal.show()
    },

    fnGetValue(props) {
      this.id = props.id
      this.status = props.status
      this.name = props.name
      this.rate = props.rate
      this.defaultFinancier = props.defaultFinancier
      this.description = props.description
    },

    fnUpdate: async function () {
      const obj = {
        name: this.name,
        rate: this.rate,
        description: this.description,
        defaultFinancier: this.defaultFinancier,
        status: this.status
      }

      try {
        const response = await financierService.update(this.id, obj)
        this.fetchFinancierPaginate(this.getFinancierPaginate)
        messageService.fnSweetAlertSuccessToast(
          'Financier',
          'Updated successfully '
        )
        this.hideModal()
      } catch (error) {
        messageService.fnSweetAlertErrorToast(
          'Financier - update',
          error.response.data.message
        )
      }

      this.id = ''
      this.name = ''
      this.rate = 0
      this.status = ''
      this.description = ''
      this.defaultFinancier = 0
    }
  }
}
</script>
